var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdaptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99722 24C4.47229 24 0 19.6225 0 14.2269H20C19.9944 19.6225 15.5221 24 9.99722 24Z",
    fill: "#91950F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99722 14.2269C5.48037 14.2269 1.82122 10.6497 1.82122 6.23413H18.1788C18.1732 10.6443 14.5141 14.2269 9.99722 14.2269Z",
    fill: "#91950F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99722 6.22868C6.47731 6.22868 3.62573 3.44102 3.62573 0H16.3743C16.3687 3.44102 13.5171 6.22868 9.99722 6.22868Z",
    fill: "#91950F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptIcon);
export default __webpack_public_path__ + "static/media/AdaptIcon.bef0e86639f3fdf5e81a4035742438c0.svg";
export { ForwardRef as ReactComponent };